import { sumNumberSafe } from './sumNumberSafe';

const winWAV = require('./../assets/audio/win.wav');
// const loseWAV = require('./../assets/audio/lose.wav')
const winSFX = new Audio(winWAV.default);
// const loseSFX = new Audio(loseWAV.default)
export const helperFinish = (
	f: any,
	balance: string,
	setisFinished: any,
	setballsOnBoard: any,
	setfinalBalance: React.Dispatch<React.SetStateAction<number>>,
	setwheelCoefs: any,
	sound: boolean
) => {
	setisFinished(true);

	setfinalBalance((state) => {
		return sumNumberSafe(state, parseFloat(balance));
	});

	setballsOnBoard((b: number) => b - 1);
	setTimeout(() => {
		setisFinished(false);
	}, 200);
	if (sound) {
		if (f.coef > 1) {
			winSFX.currentTime = 0;
			winSFX.play();
		}
	}
	if (f.coef === '1000') {
		f.coef = '1k';
	}
	setwheelCoefs((c: any) => {
		if (c.length > 6) {
			let coefs = c;
			coefs.shift();

			return [...coefs, f];
		} else {
			return [...c, f];
		}
	});
};
